
import { NodeViewContent, NodeViewWrapper } from '@tiptap/vue-2';
import { defineComponent } from 'vue';
import { lsTest } from '../../helpers/localstorage';
import { EventBus } from '../../eventbus';
import HokBgImg from '../HokBgImg.vue';

export default defineComponent({
	name: 'HokVideo',
	components: {
		NodeViewWrapper,
		NodeViewContent,
		HokBgImg
	},
	data() {
		return {
			localStorageAvailable: lsTest(),
			userHasAcceptedExternalCookies: false,
			videoUrl: '',
			thumbnail: ''
		};
	},
	mounted() {
		if (this.node.attrs.src) {
			this.videoUrl = this.node.attrs.src;
		}
		if (this.node.attrs.thumbnail) {
			this.thumbnail = this.node.attrs.thumbnail;
		}

		const acceptedCookie = this.localStorageAvailable && localStorage.getItem('accept-cookies');
		if (acceptedCookie && acceptedCookie.startsWith('[')) {
			const parsedCookie = JSON.parse(acceptedCookie);
			this.userHasAcceptedExternalCookies = !!parsedCookie.includes('externalYoutube');
		}

		EventBus().$on('accepted-tracking', parsedCookie => {
			this.userHasAcceptedExternalCookies = !!parsedCookie.includes('externalYoutube');
		});
	},
	beforeDestroy() {
		EventBus().$off('accepted-tracking');
	},
	methods: {
		openCookieBanner() {
			this.$cookieBanner.toggle(true, { stage: 'config' });
		}
	},
	props: {
		node: { type: Object, required: true }
	}
});
